var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#678134;}\r\n\t.st2{fill:#1B7D9F;}\r\n\t.st3{fill:#934D4F;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#8B7734;}\r\n\t.st6{fill:none;stroke:#678134;}\r\n\t.st7{fill:none;stroke:#934D4F;}\r\n\t.st8{fill:none;stroke:#4EA3C0;}\r\n\t.st9{fill:none;stroke:#8B7734;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Color"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "White"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 8,
    cy: 11.72,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.0455,8.76V3.65c0-0.24,0.2-0.43,0.44-0.43h1.029c0.24,0,0.44,0.19,0.44,0.43v5.11 c-0.01,0.24-0.2,0.44-0.44,0.44h-1.029C7.2455,9.2,7.0455,9,7.0455,8.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55779_00000003809610272794101960000015784032482381794981_",
    className: "st4",
    d: "M8,16c4.42,0,8-3.58,8-8 c0-4.42-3.58-8-8-8S0,3.58,0,8C0.01,12.42,3.58,15.99,8,16z M7.05,3.65c0-0.24,0.2-0.43,0.44-0.43h1.02c0.24,0,0.44,0.19,0.44,0.43 v5.11C8.94,9,8.75,9.2,8.51,9.2H7.49C7.25,9.2,7.05,9,7.05,8.76V3.65z M8,10.52c0.66,0,1.2,0.53,1.2,1.2c0,0.66-0.54,1.2-1.2,1.2 s-1.2-0.54-1.2-1.2C6.8,11.05,7.34,10.52,8,10.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmWarning);
export default __webpack_public_path__ + "static/media/TM_Warning.ea8b419f29ae623803fc53d634d4e93b.svg";
export { ForwardRef as ReactComponent };